import { ACCESS_TOKEN_AGP_KEY, ACCESS_TOKEN_BF_KEY } from '@/lib/constants'

type SetTokensData = {
  tokenAgp: string | null
  tokenBf: string | null
}

function getTokens() {
  return {
    tokenAgp: localStorage.getItem(ACCESS_TOKEN_AGP_KEY),
    tokenBf: localStorage.getItem(ACCESS_TOKEN_BF_KEY),
  }
}

function setTokens({ tokenAgp, tokenBf }: SetTokensData) {
  if (!tokenAgp || !tokenBf) return
  localStorage.setItem(ACCESS_TOKEN_AGP_KEY, tokenAgp)
  localStorage.setItem(ACCESS_TOKEN_BF_KEY, tokenBf)
}

function removeTokens() {
  localStorage.removeItem(ACCESS_TOKEN_AGP_KEY)
  localStorage.removeItem(ACCESS_TOKEN_BF_KEY)
}

export { getTokens, setTokens, removeTokens }
